import { isPlatformBrowser } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ParamFilters } from "@app/models/filtermodels/ParamFilters";
import { Partner } from "@app/models/partner/IPartner";
import { HotelFiltersService } from "@app/services/hotelfilters.service";
import { Observable, of } from "rxjs";

@Component({
  selector: "clever-keywords",
  templateUrl: "./keywords.component.html",
  styleUrls: ["./keywords.component.scss"],
  standalone: false,
})
export class KeywordsComponent implements OnInit {
  @Input() mode: string;
  @Input() partner: Partner;
  @Input() onlyLage: boolean = false;
  isBrowser: boolean = false;
  keywords: Observable<any>;
  keywordsLage = {
    code: "bea",
    slicenbr: 4,
    name: "Lage",
    jsonname: "Lage",
    childrens: [
      { code: "bea", name: "Direkt am Strand", checked: false },
      { code: "ben", name: "Strandnah", checked: false },
      { code: "lcs", name: "Zentrale Lage", checked: false },
      { code: "fwc", name: "Behindertengerecht", checked: false },
    ],
  };

  keywordList = [
    {
      code: "pol",
      slicenbr: 4,
      name: "Pool",
      jsonname: "Pool",
      childrens: [
        { code: "fcp", name: "Kinderpool", checked: false },
        { code: "ipl", name: "Hallenbad", checked: false },
        { code: "pol", name: "Pool", checked: false },
        { code: "wsl", name: "Wasserrutsche", checked: false },
      ],
    },
    {
      code: "chf",
      slicenbr: 4,
      name: "Familie",
      jsonname: "Familie",
      childrens: [
        { code: "fbs", name: "Babysitter", checked: false },
        { code: "emd", name: "Mini-Disco", checked: false },
        { code: "ecc", name: "Kinderbetreuung", checked: false },
        { code: "rcb", name: "Kinderbett", checked: false },
        { code: "chf", name: "Kinderfreundlich", checked: false },
        { code: "mcm", name: "Kindermenüs", checked: false },
        { code: "emc", name: "Miniclub", checked: false },
        { code: "fpg", name: "Spielplatz", checked: false },
        { code: "eec", name: "Unterhaltungsprogramm (Kinder)", checked: false },
        { code: "fpr", name: "Spielzimmer", checked: false },
        { code: "hca", name: "Kinderhochstuhl", checked: false },
      ],
    },
    {
      code: "wel",
      slicenbr: 4,
      name: "Wellness",
      jsonname: "Wellness",
      childrens: [
        { code: "wdt", name: "Diät", checked: false },
        { code: "wms", name: "Massage", checked: false },
        { code: "wap", name: "Akupunktur", checked: false },
        { code: "waa", name: "Anti Aging", checked: false },
        { code: "way", name: "Ayurveda", checked: false },
        { code: "wbf", name: "Beauty Farm", checked: false },
        { code: "wcu", name: "Kuranwendung", checked: false },
        { code: "wsn", name: "Dampfbad / Sauna", checked: false },
        { code: "wth", name: "Thalasso", checked: false },
        { code: "wac", name: "Aktiv sein", checked: false },
        { code: "wel", name: "Wellness", checked: false },
      ],
    },
    {
      code: "sth",
      slicenbr: 4,
      name: "Aktiv / Sport",
      jsonname: "AktivSport",
      childrens: [
        { code: "ani", name: "Animation", checked: false },
        { code: "sae", name: "Aerobic", checked: false },
        { code: "sbs", name: "Ballsport", checked: false },
        { code: "shb", name: "Hiking / Biking", checked: false },
        { code: "sdv", name: "Tauchen", checked: false },
        { code: "sfr", name: "Fitnessraum", checked: false },
        { code: "sgl", name: "Golf", checked: false },
        { code: "srd", name: "Reiten", checked: false },
        { code: "stn", name: "Tennis", checked: false },
        { code: "sws", name: "Wassersport", checked: false },
      ],
    },
    {
      code: "clb",
      slicenbr: 4,
      name: "Extras",
      jsonname: "Extras",
      childrens: [
        { code: "fwi", name: "WLAN", checked: false },
        { code: "rbe", name: "Getrennte Schlafzimmer", checked: false },
        { code: "rsm", name: "Raucherzimmer", checked: false },
        { code: "fin", name: "Internetzugang im Zimmer", checked: false },
        { code: "ado", name: "Adults Only", checked: false },
      ],
    },
  ];
  destroyRef = inject(DestroyRef);
  selectedList: string[] = [];
  constructor(
    @Inject(PLATFORM_ID) protected platformId: any,
    protected hotelService: HotelFiltersService,
    protected cdr: ChangeDetectorRef,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.initFilterSub();
      if (!this.onlyLage) {
        this.initroomTypeList();
      }
    }
  }

  initroomTypeList(): void {
    const tmp_kw = JSON.parse(JSON.stringify(this.keywordList));
    for (let i = 0; i < tmp_kw.length; i++) {
      if (this.partner?.filters?.["hide" + tmp_kw[i].jsonname + "filter"]) {
        tmp_kw.splice(i, 1);
        i--;
      } else {
        for (let j = 0; j < tmp_kw[i].childrens.length; j++) {
          if (
            this.partner?.filters?.[
              "hide" +
                tmp_kw[i].jsonname +
                tmp_kw[i].childrens[j]["code"] +
                "filter"
            ]
          ) {
            tmp_kw[i].childrens.splice(j, 1);
            j--;
          }
        }
        tmp_kw[i].slicenbr =
          tmp_kw[i].childrens?.length > 4 ? 4 : tmp_kw[i].childrens.length;
      }
    }
    this.keywords = of(tmp_kw);
    this.cdr.detectChanges();
  }

  showMore(item, all) {
    item.slicenbr = all;
  }

  initFilterSub(): void {
    this.hotelService.getfilters$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((filter: ParamFilters) => {
        this.selectedList = [];
        if (filter?.keywordList?.length > 0) {
          for (let i = 0; i < filter.keywordList.length; i++) {
            this.selectedList.push(filter.keywordList[i].code);
          }
        }
        this.cdr.detectChanges();
      });
  }

  selected(op): void {
    op.checked = true;
    let push = true;
    if (this.selectedList.indexOf(op.code) >= 0) {
      op.checked = false;
      push = false;
    }
    this.hotelService.keywordList(op, push);
    this.cdr.detectChanges();
  }
}
